import {CommonModule} from "@angular/common";
import {
  Component,
  ContentChildren,
  ElementRef, inject,
  Injector,
  Input, NgZone,
  Optional,
  QueryList, ViewChildren
} from '@angular/core';

import { IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, styler,register } from "@wm/components-base";
import {CarouselComponent, SlideComponent} from "ngx-bootstrap/carousel";
import {CarouselTemplateDirective} from "./carousel-template/carousel-template.directive";
import {WmsTranscludeDirective} from "../../../../widgets/page/wms-transclude/wms-transclude.directive";


const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-carousel'
};

const navigationClassMap: {[key: string]: string} = {
  indicators: 'hide-navs',
  navs: 'hide-indicators',
  none: 'hide-both'
};

@Component({
  selector: '[wmCarousel]',
  standalone: true,
  imports: [CommonModule, WmsTranscludeDirective],
  template: `
    <div class="carousel slide" >
      <ol class="carousel-indicators" *ngIf="!dynamicType">
        <li *ngFor="let content of contents; let i = index;" [ngClass]="{'active': activeIndex === i}" (click)="goTo(i)"></li>
      </ol>
      <div class="carousel-inner" wmsTransclude>
        <ng-content></ng-content>
      </div>
      <a class="left carousel-control" (click)="prev()" *ngIf="!dynamicType">
        <i class="wi wi-chevron-left"></i>'
      </a>
      <a class="right carousel-control" (click)="next()" *ngIf="!dynamicType">
        <i class="wi wi-chevron-right"></i>
      </a>
    </div>
  `,
  providers: [
    provideAsWidgetRef(CarouselDirective),
    CarouselComponent
  ],
  exportAs: 'wmCarousel'
})
export class CarouselDirective extends StylableComponent {
  static initializeProps = register('wm-carousel');
  @ContentChildren(SlideComponent)slides: QueryList<SlideComponent>;
  @ViewChildren(SlideComponent) slideComponents: QueryList<SlideComponent>;

  @ViewChildren(CarouselTemplateDirective) carouselTmpls: QueryList<CarouselTemplateDirective>;
  @ContentChildren(CarouselTemplateDirective) ccarouselTmpls: QueryList<CarouselTemplateDirective>;

  public contents: Array<CarouselTemplateDirective> = [];
  @Input() showIndicator: boolean = true;
  public controls: string;
  public activeIndex: number = 0;
  dynamicType: any;
  private navigationClass: string;
  private initialized: boolean = false;
  private _el: ElementRef;

  constructor(public component: CarouselComponent, inj: Injector, @Optional() viewParent: Parent, private ngZone: NgZone) {
    super(inj, WIDGET_CONFIG, viewParent);
    this._el = inject(ElementRef);
    styler(this.nativeElement, this);

  }

  override onPropertyChange(this: any, key: string, nv: any, ov?: any) {
    let widgetProperties = this.widgetProps;
    if (key === 'name') {
      this.dynamicType = this.$attrs.get('type');
    }
    if (key === 'animation') {
      if (nv === 'none') {
        widgetProperties.animationinterval.show = false;
      } else {
        widgetProperties.animationinterval.show = true;
      }

    }

    if (key === 'dataset') {
      // this.onDataChange(nv);
    } else if (key === 'controls') {
      // For showing controls
      this.navigationClass = navigationClassMap[this.controls];
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }


  register(carouselTemplate: CarouselTemplateDirective) {
    // check for the first index of the slide deck and class active
    if (!this.contents.length) {
      carouselTemplate.$element.addClass('active');
    }

    this.contents.push(carouselTemplate);
    setTimeout(() => {
      this.goTo(this.contents.length - 1);
    });
  }

  unregister(carouselTemplate: CarouselTemplateDirective) {
    this.contents.splice(this.contents.indexOf(carouselTemplate), 1);
  }

  goTo(index: any) {
    let oldElement,
      newElement,
      oldIndex,
      content = $(this._el.nativeElement).find('>.carousel>.carousel-inner'),
      items = content.find('>.app-carousel-item');

    if (items.length) {
      index = (items.length + index) % items.length;
    }

    if (index === this.activeIndex) {
      return;
    }

    // if the carousel is not animating then move to another slide.
    if (!this.contents[this.activeIndex]) {
      return;
    }

    oldElement = this.contents[this.activeIndex].$element;
    newElement = this.contents[index].$element;
    oldIndex = this.activeIndex;

    oldElement.removeClass('active');
    newElement.addClass('active');
    this.activeIndex = index;
    this.setActiveItem(items, oldIndex, index);
  }

  setActiveItem(items: any, from: number, to: number) {
    // if from and to are undefined then set to 0 index.
    from = from || 0;
    to = to || 0;

    // if there is only one carousel-item then there won't be any right or left-item.
    if (items.length === 1) {
      items.eq(0).removeClass('left-item right-item');
      return;
    }
    items.eq((items.length + from) % items.length).removeClass('left-item').addClass('right-item');
    items.eq((items.length + to - 1) % items.length).addClass('left-item').removeClass('right-item');
    items.eq((items.length + to) % items.length).removeClass('left-item right-item');
    items.eq((items.length + to + 1) % items.length).addClass('right-item').removeClass('left-item');
  }

  prev() {
    this.goTo(this.activeIndex - 1)
  }


  next() {
    this.goTo(this.activeIndex + 1)
  }


}

